if (window.innerWidth <= 749) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super(function(entries, observer) {
        entries = entries.filter(function(entry) {
          return !entry.target.classList.contains('products-mega-menu__cards');
        });
        if (entries.length > 0) callback(entries, observer);
      });
    }
  };
}

function fixMenuCards() {
  if (window.innerWidth > 749) return;
  document.querySelectorAll('.menu-drawer .products-mega-menu__cards').forEach(function(ul) {
    ul.style.setProperty('height', 'auto', 'important');
    ul.style.setProperty('flex-direction', 'column', 'important');
  });
  document.querySelectorAll('.menu-drawer .products-mega-menu__cards li').forEach(function(li) {
    li.style.setProperty('height', 'auto', 'important');
    li.style.setProperty('flex', 'none', 'important');
  });
  document.querySelectorAll('.menu-drawer .card-wrapper').forEach(function(el) {
    el.style.setProperty('height', 'auto', 'important');
  });
  document.querySelectorAll('.menu-drawer .card__inner.ratio').forEach(function(el) {
    el.style.setProperty('padding-bottom', '0', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
  });
}

document.addEventListener('click', function() {
  setTimeout(fixMenuCards, 50);
  setTimeout(fixMenuCards, 200);
  setTimeout(fixMenuCards, 600);
});

document.addEventListener('touchend', function() {
  setTimeout(fixMenuCards, 50);
  setTimeout(fixMenuCards, 200);
  setTimeout(fixMenuCards, 600);
});
